import { Link } from "react-router";
import { Arrow, Icon } from "../components/Icons";
import HeroWord from "../components/HeroWord";
import SceneView from "../components/three/SceneView";
import { portfolio } from "../data/portfolio";
import { useTheme } from "../hooks/useTheme";

export default function Hero() {
  const { theme } = useTheme();
  return (
    <section id="home" className="lab-hero" aria-labelledby="hero-title">
      <div className="lab-hero-inner container">
        {/* <div className="lab-topline mono">
          <span>
            <i className="status-dot" />
            Independent by design.
          </span>
          <span>
            Colorado, USA <span className="topline-divider">/</span> Design ×
            Code × Motion
          </span>
        </div> */}
        <div className="lab-composition">
          <div className="lab-copy">
            <p className="lab-kicker mono">
              <span>Creative front-end developer</span>
              <span className="kicker-rule" />
            </p>
            <h1 id="hero-title" className="lab-title">
              <span className="title-line">I build digital</span>{" "}
              <span className="title-line">experiences</span>{" "}
              <span className="title-line title-finale">
                that <HeroWord />
              </span>
            </h1>
            <div className="lab-intro">
              <p>
                I’m Darren, a developer based in Colorado. I build websites
                that are easy to use, with room for a little motion and a closer
                look at the details.
              </p>
            </div>
            <div className="lab-actions">
              <Link className="button primary" to="/#work">
                View selected work <Arrow diagonal />
              </Link>
              <Link className="text-link" to="/contact">
                Start a conversation <Arrow diagonal />
              </Link>
            </div>
            <p className="lab-availability">
              <span
              // className={portfolio.available ? "status-dot" : "quiet-dot"}
              />
              {portfolio.availability}
            </p>
          </div>
          <div className="hero-stage">
            <div className="stage-heading mono">
              <span>
                <i className="stage-cross" /> The performance lab
              </span>
              <span>Study 001</span>
            </div>
            <SceneView />
            <div className="stage-caption mono">
              <span>
                Connected experiences <span>/</span> {theme.name} edition
              </span>
              <span>Drag to explore <Icon name="drag" /></span>
            </div>
          </div>
        </div>
        <div className="lab-bottom">
          <a href="#work" className="lab-scroll mono">
            <span>
              <Arrow />
            </span>
            Discover the work
          </a>
          <p className="mono">
            Designed in Colorado.<span>Built by Darren.</span>
          </p>
          <Link to="/work/aero-01" className="hero-project-peek">
            <span className="peek-image">
              <img
                src="/images/projects/aero-live-thumbnail.webp"
                alt=""
                width="320"
                height="176"
              />
            </span>
            <span>
              <span className="mono">Featured project / 01</span>
              <strong>
                AERO/01 <span>Interactive product story</span>
              </strong>
            </span>
            <Arrow diagonal />
          </Link>
        </div>
      </div>
    </section>
  );
}
